import React, { RefObject, useLayoutEffect, useRef } from "react";
import ReactDOM from "react-dom";
import './index.scss'

const DropDownOptions = (props: {
    targetRef: RefObject<HTMLElement|null>;
    children: React.ReactNode,
    width: number,
    top: number,
    left: number,
    height: number,

}): JSX.Element =>
{

    
    const optContainerRef = useRef<HTMLDivElement | null>(null);


    useLayoutEffect(() =>
    {
        updateDropdownPosition(); // On mount
        window.addEventListener('scroll', updateDropdownPosition, true);
        window.addEventListener('resize', updateDropdownPosition);

        return () =>
        {
            window.removeEventListener('scroll', updateDropdownPosition, true);
            window.removeEventListener('resize', updateDropdownPosition);
        };
    }, []);


    const updateDropdownPosition = () =>
    {

        if (props.targetRef.current && optContainerRef.current)
        {
            const rect = props.targetRef.current.getBoundingClientRect();
            optContainerRef.current.style.position = 'fixed';
            optContainerRef.current.style.top = `${ rect.bottom }px`;
            optContainerRef.current.style.left = `${ rect.left }px`;
            optContainerRef.current.style.width = `${ rect.width }px`;
            optContainerRef.current.style.zIndex = `1000`;

        }
    }



    return ReactDOM.createPortal(
        <div ref={ optContainerRef }>
            { props.children }
        </div>,
        document.body
    );

    // return (<div className="dvstyle" style={{
    //         width: props.width + "px"
    //     }}>
    //     {props.children}
    // </div>)
};




export default DropDownOptions;